import { render, staticRenderFns } from "./SuperAdminPackageSettings.vue?vue&type=template&id=0f9166f4&scoped=true"
import script from "./SuperAdminPackageSettings.vue?vue&type=script&lang=js"
export * from "./SuperAdminPackageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9166f4",
  null
  
)

export default component.exports